import { render, staticRenderFns } from "./ChatOrderProfileTierModal.vue?vue&type=template&id=d3abd4a8&scoped=true&"
import script from "./ChatOrderProfileTierModal.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProfileTierModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProfileTierModal.vue?vue&type=style&index=0&id=d3abd4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3abd4a8",
  null
  
)

export default component.exports